import { vars } from "@common/styles";
import styled from "styled-components";

export const Root = styled.div`
  display: flex;
  flex-direction: row;
  height: 3.2rem;
  border-radius: 10px;
  background: #000000;
  align-items: center;
  border: 0.15rem solid ${vars.colors.grey80};
  margin-right: 0.8rem;
  padding: 0 0.6rem 0 0.6rem;
  width: 20rem;
`;

export const SearchIcon = styled.div`
  align-items: center;
  justify-content: center;
  display: flex;
  width: 1.6rem;
  height: 1.6rem;

  svg path {
    stroke: ${vars.colors.grey60};
  }
`;

export const ClearButton = styled.div`
  align-items: center;
  justify-content: center;
  display: flex;
  width: 1.6rem;
  height: 1.6rem;
  cursor: pointer;
  svg path {
    stroke: ${vars.colors.grey30};
  }
  :hover {
    opacity: 0.7;
  }
`;

export const TextInput = styled.input`
  flex: 1;

  background-color: transparent;
  border: none;
  font-weight: 500;
  font-size: 13px;
  line-height: 18px;
  letter-spacing: 0;
  color: ${vars.colors.grey30};
  min-width: 0;

  :focus {
    outline: none;
    outline-width: 0 !important;
    box-shadow: none;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
  }
`;
